import React, { useRef, useState } from "react";
import {
  AiFillFilePdf,
  AiFillFilePpt,
  AiFillFileUnknown,
  AiFillFileWord,
  AiFillFileText,
  AiFillFileZip,
  AiFillFileExcel,
  AiFillFileImage,
} from "react-icons/ai";
import { FiCheck, FiInfo } from "react-icons/fi";
import { Typography, Tooltip } from "@mui/material";
import { IconViewContainer, ListViewContainer } from "./styles";
import FilePropertiesPopover from "../FilePropertiesPopover/index";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  ellipsis: {
    maxWidth: 200, // percentage also works
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

const FileItem = ({
  fileInfo,
  selected,
  t,
  onFileClick,
  displayType,
  handleOpenFile,
}) => {
  const getFileIcon = () => {
    switch (fileInfo.extension) {
      case "pdf":
        return (
          <AiFillFilePdf
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "xlsx":
        return (
          <AiFillFileExcel
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "txt":
        return (
          <AiFillFileText
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "docx":
        return (
          <AiFillFileWord
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "ppt":
        return (
          <AiFillFilePpt
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "pptx":
        return (
          <AiFillFilePpt
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "zip":
        return (
          <AiFillFileZip
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "img":
        return (
          <AiFillFileImage
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "png":
        return (
          <AiFillFileImage
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "jpg":
        return (
          <AiFillFileImage
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      case "jpeg":
        return (
          <AiFillFileImage
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
      default:
        return (
          <AiFillFileUnknown
            color={fileInfo.deleted ? "#888888" : "#212121"}
            size={displayType !== "list" ? 56 : 16}
          />
        );
    }
  };
  const classes = useStyles();
  const containerRef = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  return displayType === "icons" ? (
    <IconViewContainer
      onDoubleClick={() => handleOpenFile(fileInfo.id)}
      ref={containerRef}
      deleted={fileInfo.deleted}
      selected={selected}
      onClick={onFileClick}
    >
      {getFileIcon()}

      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "80%",
        }}
      >
        <Tooltip aria-label={fileInfo.displayName} title={fileInfo.displayName}>
          <Typography
            className={classes.ellipsis}
            nowrap
            style={{ ...(fileInfo.deleted && { color: "#888888" }) }}
          >
            {fileInfo.displayName}
          </Typography>
        </Tooltip>
      </div>

      <div className="selectButton">{selected && <FiCheck />}</div>

      <Tooltip
        aria-label={t("menu.fileManagement.info.fileInfos")}
        title={t("menu.fileManagement.info.fileInfos")}
      >
        <div
          className="propertiesButton"
          onClick={(e) => {
            setAnchorEl(e.currentTarget);
            setOpen(true);
          }}
        >
          <FiInfo size={26} />
        </div>
      </Tooltip>

      {anchorEl && (
        <FilePropertiesPopover
          fileInfo={fileInfo}
          close={() => setOpen(false)}
          open={open}
          anchorEl={anchorEl}
          t={t}
        />
      )}
    </IconViewContainer>
  ) : (
    <ListViewContainer
      onDoubleClick={() => handleOpenFile(fileInfo.id)}
      ref={containerRef}
      deleted={fileInfo.deleted}
      selected={selected}
      onClick={onFileClick}
    >
      {getFileIcon()}

      <div
        style={{ overflow: "hidden", textOverflow: "ellipsis", width: "70%" }}
      >
        <Tooltip aria-label={fileInfo.displayName} title={fileInfo.displayName}>
          <Typography
            className={classes.ellipsis}
            nowrap
            style={{
              maxWidth: "100%",
              ...(fileInfo.deleted && { color: "#888888" }),
            }}
          >
            {fileInfo.displayName}
          </Typography>
        </Tooltip>
      </div>

      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Tooltip
          aria-label={t("menu.fileManagement.info.fileInfos")}
          title={t("menu.fileManagement.info.fileInfos")}
        >
          <div
            className="propertiesButton"
            onClick={(e) => {
              setAnchorEl(containerRef.current);
              setOpen(true);
            }}
          >
            <FiInfo size={18} />
          </div>
        </Tooltip>
      </div>

      {anchorEl && (
        <FilePropertiesPopover
          fileInfo={fileInfo}
          close={() => setOpen(false)}
          open={open}
          anchorEl={anchorEl}
          t={t}
        />
      )}
    </ListViewContainer>
  );
};

export default FileItem;
